import styled from "styled-components";

export const ContentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
`;
